import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeOff = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.6 6.6C6.22 6.97 6 7.46 6 8C6 9.1 6.9 10 8 10C8.54 10 9.03 9.78 9.4 9.4M11.6 11.6C10.6 12.33 9.34 12.67 8 12.67C3.33 12.67 1.33 8 1.33 8C2.16 6.45 3.31 5.1 4.71 4.13M6.67 3.46C7.1 3.38 7.55 3.33 8 3.33C12.67 3.33 14.67 8 14.67 8C14.27 8.75 13.79 9.45 13.24 10.09M2 2L14 14",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEyeOff;
